import React            from "react";
import Table            from "semantic-ui-react/dist/commonjs/collections/Table";
import $                from 'jquery';
import { breadcrumbs }  from "../../common/breadcrumbs";
import { modal }        from "../../common/modal";
import { TopBanner }    from "../../common/TopBanner";
import { Link }         from "../../lib/Link";

// ステータス：無効(期限切)
const STATUS_INVALID_LIMIT      = "0";
// ステータス：無効(契約)
const STATUS_INVALID_CONTRACT   = "1";
// ステータス：有効
const STATUS_VALID              = "2";
// ステータス：有効(案内中)
const STATUS_VALID_INTRODUCE    = "3";
// ステータス：キャンセル
const STATUS_CANCELD            = "4";

export class WaitList extends React.Component {
    constructor(props) {
        super(props);
        this.state ={
            isLoaded : false,
            error    : null,
        }
        this.fetchData          = this.fetchData.bind(this);
        this.handleChange       = this.handleChange.bind(this);
        this.updateWaitNotice   = this.updateWaitNotice.bind(this);
    }

    componentDidMount() {
        document.title  = "トランクルームをお探しなら『ハローストレージ』【公式】｜空き待ち登録継続確認";
        let urlParamStr = window.location.search;
        if (urlParamStr) {
          // ?id=の形で来る
          let encrypt = urlParamStr.substring(4);
          this.fetchData(encrypt);
        }
    }

    fetchData(encrypt) {
        let url = `/api/v1.2/waitlist/get/${encrypt}/`;
        fetch(url)
            .then((res)  => res.json())
            .then((json) => {
                this.setState({
                    isLoaded             : true,
                    waitList             : json.waitList,
                    waitNotice           : json.waitNotice,
                    preferred_start_date : json.waitNotice.preferred_start_date,
                });
            })
            .catch((error) =>{
                console.error(error);
            });
    }

    handleChange(event) {
        let target       = event.target;
        let value        = target.value;
        let name         = target.name;
        if (name == "preferred_start_date") {
            this.setState({preferred_start_date: value});
        } 
    }

    updateWaitNotice(mode) {
        let condition = {
            mode         : mode,
            waitNoticeId : this.state.waitNotice.id,
            waitListId   : this.state.waitNotice.wait_list_id,
        };
        let isUpdate = (mode == "update");
        if (isUpdate) {
            if (!this.state.preferred_start_date) {
                alert("利用開始希望日を入力して下さい");
                return false;
            }
            condition.preferredStartDate = this.state.preferred_start_date;
        } else {
            // 4：キャンセル
            condition.status             = STATUS_CANCELD;
        }
        let url = `/api/v1.2/waitlist/update/`;
        console.log("condition", condition);
        fetch(url, 
            {
                method     : 'POST',
                headers    : {
                    'Accept'      : 'application/json',
                    'Content-Type': 'application/json'
                },
                body   : JSON.stringify(condition)
            })
            .then((res)  => res.json())
            .then((json) => {
                modal.openModal("modal_result", condition);
                location.reload();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        const waitList   = this.state.waitList;
        const waitNotice = this.state.waitNotice;
        console.log(waitNotice);
        return (
            <div className="container">
            {breadcrumbs(this.props.type, [{ text: "空き待ち登録継続確認" }])}

            <div className="waitlist">
                <div className="toppanel">
                    <div className="title">空き待ち登録継続確認</div>
                    </div>
                    <div className="content">
                        <div className="section">
                            <div className="title">空き待ち登録継続確認</div>
                                <div className="cont_step">
                                    <div className="item">
                                    <div>
                                        {this.state.isLoaded && waitList.status == STATUS_CANCELD &&
                                            <h3 style={{color: "red"}}>この空き待ち予約は既にキャンセルされています。</h3>
                                        }
                                    </div>
                                    <div>
                                        {this.state.isLoaded && waitList.status != STATUS_CANCELD &&
                                        <div>
                                            この度は、ハローストレージ空き待ちサービスに登録頂いている方へのご案内です。
                                            <br />
                                            以前ご希望を頂きましたお部屋に空き予定がございますので、ご利用希望の確認となります。
                                            <br />
                                            以下の内容をご確認の上、空き次第利用希望か、キャンセルかのご回答をお願い致します。
                                        </div>
                                        }
                                        {this.state.isLoaded && 
                                        <div className="block">
                                            <Table celled unstackable>
                                                <Table.Body>
                                                    <Table.Row>
                                                    <Table.HeaderCell>物件名</Table.HeaderCell>
                                                    <Table.Cell>
                                                        { waitNotice.object_name }
                                                    </Table.Cell>
                                                    <Table.Cell colSpan="2">
                                                        <div 
                                                            className="waitlist-link object-detail"
                                                            onClick={() => {
                                                                let url = `/detail/${waitNotice.object_cd}`;
                                                                window.open(url);
                                                            }}
                                                        >
                                                            物件詳細
                                                        </div>
                                                    </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                    <Table.HeaderCell>お部屋</Table.HeaderCell>
                                                    <Table.Cell>
                                                        { waitNotice.dev_no }号室
                                                    </Table.Cell>
                                                    <Table.HeaderCell>タイプ</Table.HeaderCell>
                                                    <Table.Cell>
                                                        { waitNotice.jou }帖タイプ { this.state.floor }階
                                                    </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell colSpan="4">
                                                        </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                    <Table.HeaderCell>ご利用可能予定日</Table.HeaderCell>
                                                    <Table.Cell colSpan="3">
                                                        { toDateText(waitNotice.possible_start_date, true) }
                                                    </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell colSpan="4">
                                                        <p>※前契約者の利用状況により利用開始日が前後することがございます。</p>
                                                        <p>※前契約者が解約を取り消した場合は、空室待ちの権利は解除されます。</p>
                                                        </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                    <Table.HeaderCell>使用料</Table.HeaderCell>
                                                    <Table.Cell colSpan="3">
                                                        { Number(waitNotice.use_list_price).toLocaleString() }円
                                                    </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                    <Table.HeaderCell>管理費</Table.HeaderCell>
                                                    <Table.Cell colSpan="3">
                                                        { Number(waitNotice.administration_list_price).toLocaleString() }円
                                                    </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                    <Table.HeaderCell>安心保証パック</Table.HeaderCell>
                                                    <Table.Cell colSpan="3">
                                                        { Number(waitNotice.safety_guarantee_list_price).toLocaleString() }円
                                                    </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                    <Table.Cell colSpan="4">
                                                        <p>※上記費用は毎月の支払金額の定価となります。</p>
                                                        <p>※契約時に事務手数料（使用料の1ヶ月分）が別途必要となります。</p>
                                                        <p>※初期費用・月額利用料金は、契約開始前に弊社から別途ご案内致します。</p>
                                                    </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                    <Table.HeaderCell>利用開始希望日</Table.HeaderCell>
                                                    <Table.Cell colSpan="3">
                                                        <input
                                                            type        = "date"
                                                            className   = "form-control"
                                                            name        = "preferred_start_date"
                                                            value       = { this.state.preferred_start_date }
                                                            onChange    = {this.handleChange}
                                                        />
                                                    </Table.Cell>
                                                    </Table.Row>
                                                </Table.Body>
                                            </Table>
                                        </div>
                                        }
                                    </div>
                                    <div style={{textAlign: 'center'}}>
                                        <div className="waitlist-link"
                                            onClick={() => {
                                                this.updateWaitNotice('update');
                                            }}
                                        >空き次第利用希望
                                        </div>
                                        <div className="waitlist-link"
                                            onClick={() => {
                                                this.updateWaitNotice('cancel');
                                            }}
                                        >キャンセル
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

/**
 * Date型をYYY年MM月DD日+形式の文字列に変換
 * @param value
 * @returns {string}
 */
export function toDateText(value, isWareki) {
    var date = new Date(value);
    const y  = ('000' +  date.getFullYear()).slice(-4);
    const m  = ('0'   + (date.getMonth() + 1)).slice(-2);
    const d  = ('0'   +  date.getDate()).slice(-2);
    if (isWareki) {
        return `${y}年${m}月${d}日`;
    } else {
        return `${y}/${m}/${d}`;
    }
}



// WEBPACK FOOTER //
// ./pages/new/waitlist.jsx